<template>
  <div>
    <v-dialog v-model="activatedDialog" persistent max-width="290" hide-overlay>
      <v-card class="round_dialog_roles">
        <v-card-title class="headline">{{$translate('ACCOUNT_ALREADY_ACTIVATED')}}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" round @click.native="driveUserToNextScreen">{{$translate('GO')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { store } from "@/store.js";
import BaseObject from "@/objects/BaseObject";
import UserObject from "@/objects/UserObject";
import appConfig from "../../config/app_config";
import * as dssRequest from "@/api/dssRequest";
import { ui_helpers } from "../shared/ui_helpers";
import BaseComponent from "./base/BaseComponent.vue";

export default {
  name: "activateAccount",
  extends: BaseComponent,

  mixins: [ui_helpers],
  created() {
    this.readInputParams();
    window.EventBus.listen("waitForAccountState", this.verifiedAccountState);
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      "waitForAccountState",
      this.verifiedAccountState
    );
  },
  data() {
    return {
      activateObj: {},
      activatedDialog: false,
      email: "",
      userID: "",
      passwordHash: "",
      type: ""
    };
  },
  mounted() {
console.log('WE need to be sure we are getting here', );

  },
  methods: {
          verifiedAccountState(state) {
            if (state !== "ACTIVATED") this.confirmUser();
      else {
        const user = new UserObject(this.userID, this.email, "t", this.userID);
        user.userlogin(
          r => {
            console.log("activateUser success", r);
            this.activatedDialog = true;
          },
          e => {
            console.log("activateUser error", e.errorMsg);
          }
        );
      }
    },
    readInputParams() {

      this.email = this.$route.query.email;
      this.userID = this.$route.query.UserID;
      this.$store.commit("auth/setUserName", this.userID);
      this.passwordHash = this.$route.query.token;
    },
    driveUserToNextScreen() {
      this.showComponents({
        main: "EventView_Main",
        side: "EventView_Overview"
      });
      this.$store.commit("setWebStepId", 2);
    },
    confirmUser() {
      this.activateObj = UserObject._createActivateUserObject(
        appConfig.login.clientSecret,
        this.email,
        this.userID,
        this.passwordHash,
        "t"
      );
      dssRequest.doRequest(
        response => {
          console.log("The call for activateAccount was successful", response);
          let user = new UserObject(this.userID, this.email, "t", this.userID);

          this.$store.commit("auth/setToken", response.data.access_token);
          this.$store.commit(
            "auth/setRefreshToken",
            response.data.refresh_token
          );

          //disable listener to avoid loop
          window.EventBus.removeListener(
            "waitForAccountState",
            this.verifiedAccountState
          );

          user.userlogin(
            r => {
              this.$store.commit("setWebStepId", -3);
              window.EventBus.showPage("setNewAccountPreferences");
            },
            e => {
              console.log("activateUser error", e.errorMsg);
            }
          );
        },
        error => {
          console.log("The call for activateAccount was not successful", error);
        },
        "activateAccount",
         store.getters.getCurrentAccountId,
         this.activateObj
      );
    },
  }
};
</script>

<style scoped>
.greyBorder {
  border: 2px solid #c0c0c0 !important;
}

.listPadding {
  padding-left: 15px;
}
.fontWeight {
  font-weight: normal !important;
}
.navButtons {
  font-size: 2em;
  width: 100%;
  height: 100px;
  margin: 0px;
  border-radius: 0px;
  box-shadow: none !important;
  outline: 5px solid white;
}
.maxText {
  max-width: 850px !important;
}
</style>
